import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const Notifications: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 700, mx: 'auto' }}>
    <Typography variant="h4" gutterBottom>Notifications</Typography>
    <Card>
      <CardContent>
        <Typography variant="body1">Notifications will be displayed here. (Mock data for now)</Typography>
      </CardContent>
    </Card>
  </Box>
);

export default Notifications; 